export default __webpack_public_path__ + "static/media/vedioplay.cdf13d6d.svg";